import React from "react";
import moment from "moment";
import { formatDate } from "utils/dateUtils";
import EntityGrid, { loadData as entityGridLoadData } from "containers/Grid/components/EntityGrid";
import SecurityPatchHistoryToolbar from "./SecurityPatchHistoryToolbar";

const columns = [
    {
        key: "versionName",
        title: "Version Name",
        dataIndex: "versionName",
    },
    {
        key: "statusChangeTime",
        title: "Status Change Time",
        dataIndex: "statusChangeTime",
        render: formatDate,
        sorter: (a, b) => {
        if (!a.statusChangeTime || !b.statusChangeTime) return 0;
            return moment(a.statusChangeTime).valueOf() - moment(b.statusChangeTime).valueOf();
        },  
        defaultSortOrder: 'descend'  
    },
    {
        key: "previousStatus",
        title: "Previous Status",
        dataIndex: "previousStatus",
    },
    {
        key: "newStatus",
        title: "New Status",
        dataIndex: "newStatus",
    },
    {
        key: "statusMessage",
        title: "Status Message",
        dataIndex: "statusMessage",
    },
    {
        key: "commandStartTime",
        title: "Command Start Time",
        dataIndex: "commandStartTime",
        render: formatDate,
    },
];

const SecurityPatchHistoryTable = (props) => {
    const {
        fetchSecurityVersionHistories,
        securityVersionHistoryData,
        isLoading,
        setGridParams,
        resetGridData,
        grid,
        deviceId
    } = props;

    const securityPatchHistoryGrid = {
        ...grid,
        params: {
            ...grid.params,
            deviceId
        }
    };

    const refreshGrid =() => {
        entityGridLoadData(securityPatchHistoryGrid, fetchSecurityVersionHistories);
    };

    const toolbarComponent = (
        <SecurityPatchHistoryToolbar
            resetGridData={resetGridData}
            setGridParams={setGridParams}
            grid={grid}
            refreshGrid={refreshGrid}
            showAddNew={false}
        />
    );

    return (
        <EntityGrid
            toolbarComponent={toolbarComponent}
            grid={securityPatchHistoryGrid}
            fetchData={fetchSecurityVersionHistories}
            fetchDataPending={isLoading}
            data={securityVersionHistoryData}
            columns={columns}
            setGridParams={setGridParams}
            resetGridData={resetGridData}
        />
    );
};
export default SecurityPatchHistoryTable;